import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const bonuses = [{
  id: '01',
  title: 'Banco de Actividades Didácticas por Tomo',
  value: '15',
  desc: 'Un banco completo de actividades organizado por tomo y por tipo de dinámica. Análisis de fuentes, debates, representaciones históricas, propuestas de investigación y trabajo con causas y consecuencias. Cada actividad incluye instrucciones, materiales necesarios y criterios de evaluación.',
  benefit: 'Nunca más busques qué actividad hacer después de explicar un contenido. Ya está pensado, organizado y listo.'
}, {
  id: '02',
  title: 'Banco de Evaluaciones y Rúbricas Completas',
  value: '15',
  desc: 'Evaluaciones sumativas completas para cada uno de los 7 tomos. Incluye opción múltiple, respuestas cortas, ensayos, análisis de fuentes y rúbricas detalladas para facilitar la corrección y ahorrar tiempo en cada trimestre.',
  benefit: 'Nunca más construyas un examen desde cero bajo presión la noche anterior.'
}, {
  id: '03',
  title: 'Proyectos Integradores Anuales',
  value: '12',
  desc: 'Cuatro proyectos anuales diseñados para conectar distintos períodos históricos y trabajar durante varias semanas o a lo largo del ciclo escolar completo. Integran investigación, análisis, creatividad y exposición de resultados.',
  benefit: 'El tipo de proyecto que hace que los alumnos digan que la clase de historia fue la mejor del año.'
}, {
  id: '04',
  title: 'Glosario Técnico de Historia de México',
  value: '10',
  desc: 'Un glosario completo con términos históricos, arqueológicos, políticos, sociales y económicos de todos los períodos cubiertos en el Mega Pack. Listo para entregar directamente a tus alumnos como material de consulta permanente durante todo el ciclo escolar.',
  benefit: 'Nunca más pierdas tiempo de clase explicando qué significa cada concepto desde cero.'
}, {
  id: '05',
  title: 'Recursos de Pensamiento Histórico',
  value: '9',
  desc: 'Recursos diseñados para que tus alumnos no memoricen fechas y nombres — sino que aprendan a analizar fuentes, relacionar causas y consecuencias, comparar procesos históricos y entender cómo el pasado sigue influyendo en el México actual.',
  benefit: 'La diferencia entre un alumno que memoriza historia y uno que la entiende. Ese salto lo da este bono.'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-ivory border-y border-beige" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <p className="text-terracotta font-bold tracking-widest uppercase mb-2" data-id="element-18">
            Incluidos sin costo extra
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-forest" data-id="element-19">
            🎁 Los 5 Bonos Estratégicos
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-20">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-white border border-beige rounded-2xl p-8 relative group hover:border-gold/50 transition-colors shadow-sm ${index === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-1 lg:translate-x-1/2' : ''}`} data-id="element-21">
              <div className="absolute top-0 right-0 bg-gold/10 text-terracotta px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm border-b border-l border-gold/20" data-id="element-22">
                BONO {bonus.id}
              </div>

              <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center text-terracotta mb-6" data-id="element-23">
                <Gift size={24} data-id="element-24" />
              </div>

              <h3 className="text-xl font-serif font-bold mb-2 pr-16 text-forest" data-id="element-25">
                {bonus.title}
              </h3>

              <div className="inline-block bg-ivory border border-beige px-3 py-1 rounded mb-4" data-id="element-26">
                <span className="text-warmgray text-sm" data-id="element-27">
                  Valor real:{' '}
                  <span className="line-through" data-id="element-28">USD {bonus.value}</span>
                </span>
                <span className="text-emeraldbtn font-bold ml-2" data-id="element-29">→ GRATIS</span>
              </div>

              <p className="text-ink text-sm mb-6 leading-relaxed" data-id="element-30">
                {bonus.desc}
              </p>

              <p className="text-terracotta text-sm italic font-medium" data-id="element-31">
                {bonus.benefit}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-forest/5 via-gold/10 to-forest/5 border border-gold/30 rounded-2xl p-8 text-center max-w-2xl mx-auto shadow-sm" data-id="element-32">
          <p className="text-ink font-medium mb-2" data-id="element-33">
            Valor total de los 5 bonos
          </p>
          <p className="text-2xl text-warmgray line-through mb-4" data-id="element-34">USD 61,00</p>
          <p className="text-lg text-forest font-bold mb-2" data-id="element-35">Tu precio hoy</p>
          <p className="text-5xl font-bold text-green-gradient mb-4" data-id="element-36">
            🎁 GRATIS
          </p>
          <p className="text-sm text-terracotta font-medium" data-id="element-37">
            Solo incluidos en esta oferta.
          </p>
        </motion.div>

        <CountdownTimer data-id="element-38" />
      </div>
    </section>;
}